module.exports = __webpack_public_path__ + "static/media/ic-phone.d4c6ea17.svg";